export default "__VITE_ASSET__C2_ZXU2H__"